import { Link } from 'react-router-dom';

const seoArticles = [
  {
    slug: 'guida-itaobuy-spreadsheet',
    title: 'Guida Completa Itaobuy Spreadsheet 2026',
    excerpt: 'Scopri tutto su Itaobuy Spreadsheet: come funziona, le categorie, le QC Photos e consigli per acquisti sicuri.',
    tag: 'Guida',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20fashion%20editorial%20with%20soft%20cream%20and%20beige%20toned%20textiles%20artfully%20draped%20on%20a%20light%20wooden%20table%2C%20warm%20natural%20daylight%20creating%20gentle%20shadows%2C%20clean%20aesthetic%20organic%20textures%2C%20lifestyle%20product%20photography%2C%20peaceful%20atmosphere%2C%20no%20people&width=800&height=450&seq=article-card-guida-itaobuy&orientation=landscape',
    imageAlt: 'Guida completa Itaobuy Spreadsheet 2026',
  },
  {
    slug: 'sicurezza-acquisti-online',
    title: 'Sicurezza Acquisti Online: Guida Completa',
    excerpt: 'Tutto sulla sicurezza con Itaobuy Spreadsheet: protezione dati, metodi di pagamento e verifica prodotti.',
    tag: 'Sicurezza',
    imageUrl: 'https://readdy.ai/api/search-image?query=Clean%20minimalist%20security%20concept%20with%20a%20modern%20shopping%20bag%20and%20shield%20symbol%20on%20a%20soft%20cream%20background%2C%20warm%20natural%20lighting%2C%20elegant%20product%20photography%20style%2C%20organic%20textures%2C%20trustworthy%20and%20calm%20atmosphere%2C%20no%20people&width=800&height=450&seq=article-card-sicurezza&orientation=landscape',
    imageAlt: 'Sicurezza acquisti Itaobuy Spreadsheet',
  },
  {
    slug: 'guida-principianti',
    title: 'Guida per Principianti: Inizia da Zero',
    excerpt: 'Una guida passo-passo per chi si avvicina per la prima volta a Itaobuy Spreadsheet.',
    tag: 'Tutorial',
    imageUrl: 'https://readdy.ai/api/search-image?query=Clean%20minimalist%20beginner%20guide%20concept%20with%20a%20notebook%20and%20elegant%20fashion%20accessories%20on%20a%20light%20wooden%20desk%2C%20soft%20natural%20daylight%2C%20warm%20cream%20tones%2C%20simple%20and%20inviting%20atmosphere%2C%20no%20people&width=800&height=450&seq=article-card-principianti&orientation=landscape',
    imageAlt: 'Guida principianti Itaobuy Spreadsheet',
  },
  {
    slug: 'migliori-prodotti-2026',
    title: 'Migliori Prodotti 2026: Classifica Top',
    excerpt: 'Scopri la classifica aggiornata dei prodotti più popolari e meglio valutati su Itaobuy Spreadsheet.',
    tag: 'Top Prodotti',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20product%20display%20with%20beautiful%20fashion%20items%20neatly%20arranged%20on%20a%20marble%20surface%2C%20soft%20cream%20and%20warm%20beige%20tones%2C%20natural%20daylight%20from%20a%20large%20window%2C%20minimalist%20and%20clean%20composition%2C%20no%20people&width=800&height=450&seq=article-card-migliori&orientation=landscape',
    imageAlt: 'Migliori prodotti Itaobuy Spreadsheet 2026',
  },
  {
    slug: 'come-usare-itaobuy',
    title: 'Come Usare Itaobuy: Tutorial Completo',
    excerpt: 'Un tutorial dettagliato su come sfruttare al massimo Itaobuy Spreadsheet con trucchi e consigli.',
    tag: 'Tutorial',
    imageUrl: 'https://readdy.ai/api/search-image?query=Clean%20workspace%20with%20a%20laptop%20and%20elegant%20fashion%20items%20on%20a%20minimalist%20wooden%20desk%2C%20soft%20natural%20light%20from%20a%20window%2C%20warm%20cream%20and%20sage%20green%20accents%2C%20modern%20and%20inviting%20atmosphere%2C%20no%20people&width=800&height=450&seq=article-card-come-usare&orientation=landscape',
    imageAlt: 'Come usare Itaobuy Spreadsheet tutorial',
  },
  {
    slug: 'confronto-prezzi-qualita',
    title: 'Confronto Prezzi e Qualità per Categorie',
    excerpt: 'Analisi approfondita del rapporto qualità-prezzo nelle principali categorie di prodotti.',
    tag: 'Confronto',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20comparison%20concept%20with%20two%20sides%20of%20fashion%20items%20on%20a%20split%20cream%20and%20warm%20beige%20background%2C%20soft%20natural%20lighting%2C%20minimalist%20product%20photography%2C%20clean%20aesthetic%20with%20organic%20shadows%2C%20no%20people&width=800&height=450&seq=article-card-confronto&orientation=landscape',
    imageAlt: 'Confronto prezzi qualità Itaobuy Spreadsheet',
  },
  {
    slug: 'qc-photos-guida-completa',
    title: 'QC Photos: Guida Definitiva 2026',
    excerpt: 'Impara a leggere le QC Photos come un esperto per riconoscere prodotti di qualità.',
    tag: 'QC Photos',
    imageUrl: 'https://readdy.ai/api/search-image?query=Minimalist%20photography%20concept%20with%20a%20magnifying%20glass%20and%20elegant%20fashion%20textile%20details%20on%20a%20soft%20cream%20surface%2C%20warm%20natural%20lighting%2C%20macro%20detail%20style%2C%20clean%20and%20precise%20aesthetic%2C%20no%20people&width=800&height=450&seq=article-card-qc-photos&orientation=landscape',
    imageAlt: 'QC Photos guida completa',
  },
  {
    slug: 'recensione-completa-2026',
    title: 'Recensione Completa 2026: Pro e Contro',
    excerpt: 'Recensione onesta basata su mesi di utilizzo reale: punti di forza, criticità e verdetto finale.',
    tag: 'Recensione',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20review%20concept%20with%20five%20golden%20stars%20and%20beautiful%20fashion%20items%20on%20a%20cream%20textured%20background%2C%20soft%20warm%20lighting%2C%20minimalist%20composition%2C%20editorial%20photography%20style%2C%20clean%20and%20trustworthy%20aesthetic%2C%20no%20people&width=800&height=450&seq=article-card-recensione&orientation=landscape',
    imageAlt: 'Recensione Itaobuy Spreadsheet 2026',
  },
  {
    slug: 'guida-categorie-prodotti',
    title: 'Guida alle Categorie di Prodotti',
    excerpt: 'Esplora nel dettaglio tutte le categorie: Scarpe, Felpe, Accessori, Borse, Profumi e molto altro.',
    tag: 'Categorie',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20organized%20display%20of%20various%20fashion%20categories%20with%20shoes%20bags%20accessories%20and%20clothing%20items%20neatly%20arranged%20on%20shelves%2C%20warm%20natural%20lighting%2C%20cream%20and%20beige%20tones%2C%20boutique%20aesthetic%2C%20no%20people&width=800&height=450&seq=article-card-categorie&orientation=landscape',
    imageAlt: 'Guida categorie Itaobuy Spreadsheet',
  },
  {
    slug: 'risparmiare-acquisti-online',
    title: 'Risparmiare con Itaobuy: Strategie',
    excerpt: 'Le migliori strategie per risparmiare: confronto prezzi, offerte e acquisti intelligenti.',
    tag: 'Risparmio',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20savings%20concept%20with%20a%20piggy%20bank%20and%20beautiful%20minimalist%20fashion%20items%20on%20a%20soft%20cream%20surface%2C%20warm%20natural%20daylight%2C%20clean%20and%20smart%20aesthetic%2C%20editorial%20lifestyle%20photography%2C%20no%20people&width=800&height=450&seq=article-card-risparmiare&orientation=landscape',
    imageAlt: 'Risparmiare con Itaobuy Spreadsheet',
  },
];

export default function ArticlePreviewGrid() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-4">
            Articoli SEO
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
            Guide e Articoli su Itaobuy Spreadsheet
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
            Esplora la nostra raccolta completa di guide, tutorial e recensioni per diventare un esperto di Itaobuy Spreadsheet.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {seoArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/articolo/${article.slug}`}
              className="group flex flex-col bg-background-50 rounded-xl border border-background-200/70 hover:border-primary-300 transition-all duration-300 overflow-hidden cursor-pointer"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.imageAlt}
                  title={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold">
                  {article.tag}
                </span>
              </div>
              <div className="p-5 flex flex-col flex-1">
                <h3 className="font-heading text-base font-bold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors leading-snug">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed flex-1">
                  {article.excerpt}
                </p>
                <div className="mt-4 flex items-center gap-1 text-primary-500 text-sm font-medium">
                  <span>Leggi articolo</span>
                  <span className="w-4 h-4 flex items-center justify-center group-hover:translate-x-1 transition-transform">
                    <i className="ri-arrow-right-line text-sm"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}